import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class UserModel extends ApiModel {
  static get path() {
    return '/backend/users/{?id}';
  }

  @computed
  get enabled(): boolean {
    return this.get('enabled');
  }

  @computed
  get fullName(): string {
    return `${this.get('firstName')} ${this.get('lastName')}`;
  }

  @computed
  get company(): string {
    return this.get('company', '');
  }

  @computed
  get lastName(): string {
    return this.get('lastName');
  }

  @computed
  get firstName(): string {
    return this.get('firstName');
  }

  @computed
  get email(): string {
    return this.get('email');
  }

  @computed
  get username(): string {
    return this.get('username');
  }

  @computed
  get phone(): string {
    return this.get('phone');
  }

  @computed
  get role(): string {
    return this.get('role');
  }

  @computed
  get roleId(): id {
    return this.get('role.id');
  }

  @computed
  get roleIri(): string {
    return this.get('role.@id');
  }

  @computed
  get languagePreference(): string|null {
    return this.get('languagePreference', null);
  }
}
